import React from 'react';
import * as Styled from './MTextBlockSimple.styles';
import { MTextBlockSimpleProps, MTextBlockSimpleAlignment } from './MTextBlockSimple.types';

import { AEyebrow, AEyebrowVariant } from '../../atoms/AEyebrow';
import { AHeader, AHeaderSize } from '../../atoms/AHeader';
import { ABody, ABodyColor } from '../../atoms/ABody';

const COMPONENT_NAME = 'm-web-ui-kit-MTextBlockSimple';
const TEST_ID = 'web-ui-kit-MTextBlockSimple';

export const MTextBlockSimple = ({
  alignment = MTextBlockSimpleAlignment.Left,
  eyebrowText,
  eyebrowVariant = AEyebrowVariant.Primary,
  headerText,
  headerSize = AHeaderSize.TitleM,
  headerTag,
  bodyText,
  bodySize,
  bodyColor = ABodyColor.Default,
  aBody,
  aEyebrow,
  aHeader,
}: MTextBlockSimpleProps) => {
  // Prefer the nested atom props; fall back to the deprecated flat props.
  const resolvedEyebrowText = aEyebrow?.eyebrowText ?? eyebrowText;
  const resolvedEyebrowVariant = aEyebrow?.variant ?? eyebrowVariant;

  const resolvedHeaderText = aHeader?.text ?? headerText;
  const resolvedHeaderSize = aHeader?.size ?? headerSize;
  const resolvedHeaderTag = aHeader?.headerTag ?? headerTag;

  const resolvedBodyText = aBody?.bodyText ?? bodyText;
  const resolvedBodySize = aBody?.size ?? bodySize;
  const resolvedBodyColor = aBody?.color ?? bodyColor;
  const resolvedBodyClassName = aBody?.className;

  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} alignment={alignment}>
      {resolvedEyebrowText && <AEyebrow variant={resolvedEyebrowVariant}>{resolvedEyebrowText}</AEyebrow>}
      {resolvedHeaderText && (
        <AHeader
          size={resolvedHeaderSize}
          text={resolvedHeaderText}
          {...(resolvedHeaderTag ? { headerTag: resolvedHeaderTag } : {})}
          {...(aHeader?.id ? { id: aHeader.id } : {})}
        ></AHeader>
      )}
      {resolvedBodyText && (
        <ABody
          bodyText={resolvedBodyText}
          size={resolvedBodySize}
          color={resolvedBodyColor}
          className={resolvedBodyClassName}
        />
      )}
    </Styled.Wrapper>
  );
};

export { MTextBlockSimpleAlignment, TEST_ID as M_TEXT_BLOCK_SIMPLE_TEST_ID };
